<template>
   <div>
      <acheader></acheader>
      <div class="row mainbody">
        <div class="col-lg-2 col-md-4 col-sm-12">
          <clientsidebar></clientsidebar>
        </div>
        <div class="col-lg-10 col-md-8 col-sm-12">
          <div class="moduleWrapper">
            <div class="moduleCard">
              <div class="row">
                <div class="col-6">
                  <h1>New Message</h1>
                </div>
                <div class="col-6 text-right">
                  <button @click="doInbox" class="btn btn-secondary btn-medium">Return to Inbox</button>
                </div>
              </div>
              <sendmessage :presetAddresses="toAddresses" :allowForceEmail="false" :routeOnSend="rOnSend" v-if="toAddresses!==null"></sendmessage>
            </div>
          </div>
        </div>
      <div class="clearfix"></div></div><acfooter></acfooter>
    </div>
  </template>

  <script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import sendmessage from "../../components/SendMessage.vue"

   export default {
      name: "NewMessage",
      components:{acheader,acfooter,clientsidebar,sendmessage},
      data() {
        return {
          rOnSend: null,
          toAddresses: null
        }
      },
      methods: {
        doInbox() {
          this.$router.push("/client/"+this.udata.ClientID+"/inbox");
        },
      },
      mounted() {
        this.doPage().then(r=>{

          this.bootstrapClient(this.udata.ClientID);

          this.rOnSend="/client/"+this.udata.ClientID+"/inbox";

          try {
            if (this.$route.params.replyid.length<=1) {
              this.toAddresses=[];
            }
            else if (this.$route.params.replyid.length>1) {
              this.toAddresses=[this.$route.params.replyid];
            }
          }
          catch(e) {
            this.toAddresses=[];
          }

        });
      }
   }
  </script>
